export default "__VITE_ASSET__DgWD3XAT__"